import { render, staticRenderFns } from "./HeaderNewsPage.vue?vue&type=template&id=46213425"
import script from "./HeaderNewsPage.vue?vue&type=script&lang=js"
export * from "./HeaderNewsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CampusDropDownMenuHeader: require('/home/etienne/AM-frontend/components/CampusDropDownMenuHeader.vue').default})
